import React, { useEffect, useState } from 'react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { useMessage } from '../../../hooks'
import { Row, Col, DropdownMenu } from '@paypalcorp/pp-react'
import _filter from 'lodash.filter'

import { getAppSelection, setAppSelection } from '../../../utils/session-utils'

function AppSwitcher() {
  const localizedMsg = useMessage()

  const {
    enviroment,
    homePageDataLoading,
    currentApps,
    setCurrentAppValue,
    setReloadPage,
    setCurrentLiveApp,
    setCurrentSandboxApp,
  } = useApplicationContext()
  const [appList, setAppList] = useState([])
  const [selectedApp, setSelectedApp] = useState()

  /* Param 'list' will always have 1+ items */
  const manageAppSelection = (list) => {
    let appInSession = getAppSelection()
    let appCheck = _filter(list, ['value', appInSession])

    /* If app stored in session is no longer in the app-list, pick the first app */
    let appToSelect = appCheck.length === 0 ? list[0].value : appCheck[0].value
    setSelectedApp(appToSelect)
    setAppSelection(appToSelect)

    /* If selection stored in session was 'All Apps' */
    if (appToSelect === 'apps') {
      setCurrentAppValue(list[1].value)
    } else {
      setCurrentAppValue(appToSelect)
    }
    if (enviroment === 'live') {
      setCurrentLiveApp(appToSelect)
    } else {
      setCurrentSandboxApp(appToSelect)
    }
  }

  useEffect(() => {
    if (homePageDataLoading === undefined || homePageDataLoading === true) {
      return
    }
    let list
    if (!currentApps || (currentApps && currentApps.length === 0)) {
      list = []
    } else {
      try {
        list = JSON.parse(JSON.stringify(currentApps))
      } catch (err) {
        list = []
      }
    }
    if (enviroment === 'live' && list.length > 0) {
      list.unshift({
        name: localizedMsg('dashboard.app.switcher.set.allapps'),
        clientid: 'apps',
        primaryText: localizedMsg('dashboard.app.switcher.set.allapps'),
        value: 'apps',
      })
    }
    setAppList(list)

    /* 
      Auto selecting a value in the app-switcher makes sense only if there is an actual app present
    */
    if (list.length > 0) {
      manageAppSelection(list)
    }
  }, [homePageDataLoading])

  const onClickAppSwitcherEvent = (e) => {
    setSelectedApp(e.target.value)
    setAppSelection(e.target.value)
    if (e.target.value === 'apps') {
      setCurrentAppValue(appList?.[1].value)
    } else {
      setCurrentAppValue(appList?.[e.target.selectedIndex]?.value)
    }
    if (enviroment === 'live') {
      setCurrentLiveApp(e.target.value)
    } else {
      setCurrentSandboxApp(e.target.value)
    }
    setReloadPage('yes')
  }

  const appsContent = (
    <>
      <Row>
        <Col>
          <DropdownMenu
            id="selected-app"
            label={localizedMsg('dashboard.app.switcher.dropdown.set')}
            options={appList}
            value={selectedApp}
            onChange={(e) => {
              onClickAppSwitcherEvent(e)
            }}
            data-dxa={`
                App Switcher, 
                apps-value-dropdown click,
              `}
          />
        </Col>
      </Row>
    </>
  )

  return (
    <>
      {(appList.length > 2 && enviroment === 'live') ||
      (appList.length > 1 && enviroment === 'sandbox')
        ? appsContent
        : null}
    </>
  )
}

export default AppSwitcher
